import React from "react"
import { Input } from "formik-antd"

export default {
  name: {
    input: () => <Input size="large" placeholder="e.g. Adidas" />,
    label: "Company Name"
  }
}
